import Axios, { InternalAxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
export const axios = Axios.create({
  baseURL: import.meta.env.VITE_AAA_API_URL,
});
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = Cookies.get('accessToken');
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  return config;
}


axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
